/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 *
 * @author Maxim Fedorov
 * @author Anton Panasenko
 * @version 1.2.0
 * @since 1.1.0
 */

import { EChartDataKeyEnum, IChartDataInput, IChartErrorConfiguration } from '../../chartTypes';

export const ChartDynamicErrorLegendItems: IChartDataInput[] = [
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 6,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: '',
        [EChartDataKeyEnum.y]: {},
    },
];

export const ChartDynamicErrorConfiguration: IChartErrorConfiguration = {
    legendItems: ChartDynamicErrorLegendItems,
};
